import JSXComponent from "../../../dist/jsx-render/JSXComponent";
import dom from "../../../dist/jsx-render/dom";
import { IClientGridView } from "./IClientGridView";
import { AvailableFieldsComponent } from "./AvailableFieldsComponent";
import { UsedFieldsComponent } from "./UsedFieldsComponent";
import { app } from "../App";
import { GridViewSaveData } from "./GridViewSaveData";
import { IListItem } from "../../Model/IListItem";
import { GridViewSelectFilter } from "./GridViewSelectFilter";
import { TreeView } from "../../Components/TreeView/TreeView";
import { CheckedState } from "../../Components/TreeView/Models/enums/CheckedState";
import { GridViewSelectSort } from "./GridViewSelectSort";
import { SortCondition } from "../../Pages/Measure/VisibilityDependency/SortCondition";
import { CheckboxCompoment } from "../../Components/CheckboxComponent";
import { ListView } from "../../Components/ListView/ListView";
import { GridViewSelectOptions } from "./GridViewSelectOptions";
import { GridViewOptions } from "./GridViewOptions";
import { TextComponent } from "../../Components/TextComponent";



export type GridViewSelectPopupProps = {
    model: IClientGridView,
    isCopy: boolean;
    isNew: boolean;
    canCreatePublic: boolean;
    onViewChanged?: (id: string) => void;
    dontChangeUserView?: boolean;
    postSaveHandler: (name: string, id: string) => void;
    dataTemplateId: number;
    editingScenario: boolean;
}

export class GridViewSelectPopup extends JSXComponent {
    private props: GridViewSelectPopupProps;
    private availableFields: AvailableFieldsComponent;
    private element: HTMLElement;
    private usedFields: UsedFieldsComponent;
    private newTree: TreeView;
    private options: GridViewOptions;
    private linkToListviewValue: string;

    constructor(props: GridViewSelectPopupProps) {
        super(props);
        this.options = new GridViewOptions();
        this.options.UseAvatars = this.props.model.useAvatars;
        this.options.SingleLineDisplay = this.props.model.singleLineDisplay;
        this.options.ResultLineDisplay = this.props.model.resultLineDisplay;
        this.options.HideDuplicatesOption = this.props.model.hideDuplicatesOption;
        this.options.InlineEdit = this.props.model.inlineEdit;

        if (this.props.model.id != 0)
            this.linkToListviewValue = app.resolveUrl("~/Measures/MeasureList?openListview=" + this.props.model.id);
        else
            this.linkToListviewValue = "";
    }

    inputName: HTMLInputElement =
        <input className="form-control" type="text" value={this.props.model.name} />

    radioPublic: HTMLInputElement =
        <input class="form-check-input" type="radio" name="gvspView" id="gvspPublic" value="1" />

    radioPrivate: HTMLInputElement =
        <input class="form-check-input" type="radio" name="gvspView" id="gvspPrivate" value="2" />

    cbAdministrative: HTMLInputElement =
        <input class="form-check-input" type="checkbox" name="cbAdministrative" id="cbAdministrative" />

    selectChild: HTMLSelectElement =
        <select className="form-control">
            <option value="0">({Resources.Common.noUseOfSubView})</option>
            {this.props.model.views.map((item: IListItem) =>
                <option value={item.id}>{item.name}</option>
            )}
        </select>

    listViewGroupName: HTMLInputElement =
        <input className="form-control" type="text" value={this.props.model.groupName ? this.props.model.groupName : ""} />

    inputNewMeasureTemplateIds: HTMLInputElement =
        <input className="form-control" type="text" value={this.props.model.newMeasureTemplateIds ? this.props.model.newMeasureTemplateIds : ""} />

    inputRowClickUrl: HTMLInputElement =
        <input className="form-control" type="text" value={this.props.model.rowClickUrl ? this.props.model.rowClickUrl : ""} />

    checkboxUsePopup: HTMLInputElement =
        <input type="checkbox" className="form-check-input" name="gvspUsePopup" id="gvspUsePopup" />

    render() {
        if (!this.props.model.selectedExcelTemplates) this.props.model.selectedExcelTemplates = [];
        if (!this.props.model.selectedReports) this.props.model.selectedReports = [];

        this.availableFields = new AvailableFieldsComponent({ model: this.props.model });
        this.usedFields = new UsedFieldsComponent({ model: this.props.model, availableComponent: this.availableFields });

        this.element =
            <div className="modal" tabindex="-1" role="dialog" data-backdrop="static">
                <div className="modal-dialog modal-lg grid-view-modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{Resources.Common.viewEdit}</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <ul className="nav nav-tabs d-flex flex-row" role="tablist">
                                <li className="nav-item">
                                    <a className="nav-link active flex-grow-1" id="gvspCommonTab" data-toggle="tab" href="#gvspCommon" role="tab"
                                        aria-controls="gvspCommon" aria-selected="true">{Resources.Common.general}</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link flex-grow-1" id="gvspFieldsTab" data-toggle="tab" href="#gvspFields" role="tab"
                                        aria-controls="gvspFields" aria-selected="false">{Resources.Common.fields}</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link flex-grow-1" id="gvspFilterTab" data-toggle="tab" href="#gvspFilter" role="tab"
                                        aria-controls="gvspFilter" aria-selected="false">{Resources.Common.filter}</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link flex-grow-1" id="gvspSortTab" data-toggle="tab" href="#gvspSort" role="tab"
                                        aria-controls="gvspSort" aria-selected="false">{Resources.Common.sort}</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link flex-grow-1" id="gvspExportTab" data-toggle="tab" href="#gvspExport" role="tab"
                                        aria-controls="gvspExport" aria-selected="false">{Resources.Common.export}</a>
                                </li>
                            </ul>
                            <div className="tab-content mt-2">
                                <div class="tab-pane fade show active" id="gvspCommon" role="tabpanel" aria-labelledby="gvspCommonTab">
                                    <div className="form-group ansicht-name">
                                        <label className="form-label">{Resources.Common.labelName}</label>
                                        {this.inputName}
                                    </div>
                                    <div className="form-group">
                                        <label className="form-label">{Resources.Common.labelType}</label>
                                        <div class="form-check">
                                            {this.radioPublic}
                                            <label class="form-check-label" for="gvspPublic">{Resources.Common.publicView}</label>
                                        </div>
                                        <div class="form-check">
                                            {this.radioPrivate}
                                            <label class="form-check-label" for="gvspPrivate">{Resources.Common.privateView}</label>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div class="form-check">
                                            {this.cbAdministrative}
                                            <label class="form-check-label" for="cbAdministrative">{Resources.Common.administrativeView}</label>
                                        </div>
                                    </div>
                                    {this.props.model.useChildViews ?
                                        <div className="form-group">
                                            <label className="form-label">{Resources.Common.subordinateView}</label>
                                            {this.selectChild}
                                        </div>
                                        : ""}
                                    {/*Listview Settings part : UseAvatars, ResultLine, etc...*/}
                                    <GridViewSelectOptions model={this.options} showInline={false} />

                                    {/*Link to vlistview*/}
                                    <div className="form-group ansicht-link">
                                        <label className="form-label">{Resources.Common.linkToView}</label>
                                        <input className="form-control" type="text" value={this.linkToListviewValue} readonly />
                                    </div>
                                    <div className="form-group">
                                        <label className="form-label">{Resources.Common.labelMenuName}</label>
                                        {this.listViewGroupName}
                                    </div>
                                    {app.cockpitVerwaltungAktiv ?
                                        <div className="form-group ansicht-template-ids">
                                            <label className="form-label">{Resources.Common.labelNewMeasureTemplateIds}</label>
                                            {this.inputNewMeasureTemplateIds}
                                        </div>
                                        : ""}
                                    {app.cockpitVerwaltungAktiv ?
                                        <div className="form-group ansicht-row-click-url">
                                            <label className="form-label">{Resources.Common.labelRowClickUrl}</label>
                                            {this.inputRowClickUrl}
                                        </div>
                                        : ""}
                                    {app.cockpitVerwaltungAktiv ?
                                        <div className="form-check">
                                            {this.checkboxUsePopup}
                                            <label className="form-check-label" for="gvspUsePopup">{Resources.Common.usePopup}</label>
                                        </div>
                                        : ""}

                                    <TextComponent model={this.props.model}
                                        additionalCssClasses="mt-2"
                                        field="lazyLoadingAmount"
                                        restrictTo="integer"
                                        name={Resources.Common.viewLazyLoadingAmount} />
                                </div>
                                <div class="tab-pane fade" id="gvspFields" role="tabpanel" aria-labelledby="gvspFieldsTab">
                                    <div className="fields-frame">
                                        <div className="fields-column available">
                                            <div className="form-label">{Resources.Common.availableFields}</div>
                                            <div className="list mr-3">
                                                {this.availableFields.render()}
                                            </div>
                                        </div>
                                        <div className="fields-column used">
                                            <div className="form-label">{Resources.Common.selectedFields}</div>
                                            <div className="list">
                                                {this.usedFields.render()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="gvspFilter" role="tabpanel" aria-labelledby="gvspFilterTab">
                                    <GridViewSelectFilter decimalChar={this.props.model.decimalChar} model={this.props.model.filters} availableFields={this.props.model.available} />
                                </div>
                                <div class="tab-pane fade" id="gvspSort" role="tabpanel" aria-labelledby="gvspSortTab">
                                    <GridViewSelectSort model={this.props.model.sorts} availableFields={this.props.model.available} />
                                </div>
                                <div class="tab-pane fade" id="gvspExport" role="tabpanel" aria-labelledby="gvspExportTab">

                                    <CheckboxCompoment model={this.props.model}
                                        field="showOnlySelectedReporting"
                                        label={Resources.Common.showOnlySelectedReports}
                                        createFormGroup={true}
                                    />

                                    <div className="form-group">
                                        <label className="form-label">{Resources.Common.availableReports}</label>
                                        <ListView model={this.props.model.availableReports}
                                            allowSelect={true}
                                            selectedIds={this.props.model.selectedReports}
                                            displayProperty="name"
                                            idProperty="id"
                                            updateSelectedIds={true}
                                        />
                                    </div>

                                    <div className="mb-4"></div>

                                    <CheckboxCompoment model={this.props.model}
                                        field="showOnlySelectedExcel"
                                        label={Resources.Common.showOnlySelectedExcel}
                                        createFormGroup={true}
                                    />


                                    <div className="form-group">
                                        <label className="form-label">{Resources.Common.availableExcelTemplates}</label>
                                        <ListView model={this.props.model.availableExcelTemplates}
                                            allowSelect={true}
                                            selectedIds={this.props.model.selectedExcelTemplates}
                                            displayProperty="name"
                                            idProperty="id"
                                            updateSelectedIds={true}
                                        />
                                    </div>

                                    <div className="mb-4"></div>

                                    <div className="form-group">
                                        <label className="form-label">{Resources.Common.export}</label>
                                        <CheckboxCompoment model={this.props.model}
                                            field="hideButtonExport"
                                            label={Resources.Common.hideExportButton}
                                            createFormGroup={false}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button id="gvspCancel" type="button" className="btn btn-cancel btn-mso" data-dismiss="modal">{Resources.Common.cancel}</button>
                            <button id="gsvpSave" type="button" className="btn btn-save btn-mso">{Resources.Common.save}</button>
                        </div>
                    </div>
                </div>
            </div>

        if (this.props.model.isAdministrative) {
            this.cbAdministrative.checked = true;
        }

        if (this.props.model.isPublic && this.props.canCreatePublic) {
            this.radioPublic.checked = true;
            this.cbAdministrative.disabled = false;
        }
        else {
            this.radioPrivate.checked = true;
            this.cbAdministrative.disabled = true;
        }

        if (!this.props.canCreatePublic) {
            this.radioPublic.disabled = true;
        }

        if (this.props.model.useChildViews) {
            this.selectChild.value = this.props.model.childViewId.toString();
        }

        if (this.props.model.rowClickUrlUsePopup) {
            this.checkboxUsePopup.checked = true;
        }

        this.element.querySelector(".ansicht-name input")?.addEventListener("change", this.onChange);

        this.radioPublic.addEventListener("change", this.onPublicChange);
        this.radioPrivate.addEventListener("change", this.onPrivateChange);

        this.element.querySelector(".btn-save").addEventListener("click", this.onSaveClick);
        $(this.element).modal();
        $(this.element).on('hidden.bs.modal', this.onHidden);

        return this.element;
    }

    onChange = (ev: Event) => {
        const nameInput = (ev.currentTarget as HTMLInputElement);
        if (nameInput.value)
            nameInput.classList.remove("border-danger");
    }

    onPublicChange = () => {
        this.cbAdministrative.disabled = false;
    }

    onPrivateChange = () => {
        this.cbAdministrative.disabled = true;
        this.cbAdministrative.checked = false;
    }

    onSaveClick = () => {
        const saveData = new GridViewSaveData();
        saveData.id = this.props.model.id;
        saveData.name = this.inputName.value;
        saveData.isPublic = this.radioPublic.checked;
        saveData.isAdministrative = this.cbAdministrative.checked;
        saveData.useAvatars = this.options.UseAvatars;
        saveData.singleLineDisplay = this.options.SingleLineDisplay;
        saveData.resultLineDisplay = this.options.ResultLineDisplay;
        saveData.hideDuplicatesOption = this.options.HideDuplicatesOption;
        saveData.inlineEdit = this.options.InlineEdit;
        saveData.fields = [];
        saveData.childViewId = parseInt(this.selectChild.value);
        saveData.isCopy = this.props.isCopy;
        saveData.filters = [];
        saveData.sorts = null;
        saveData.newMeasureTemplateIds = this.inputNewMeasureTemplateIds.value;
        saveData.rowClickUrl = this.inputRowClickUrl.value;
        saveData.rowClickUrlUsePopup = this.checkboxUsePopup.checked;
        saveData.showOnlySelectedReporting = this.props.model.showOnlySelectedReporting;
        saveData.showOnlySelectedExcel = this.props.model.showOnlySelectedExcel;
        saveData.hideButtonExport = this.props.model.hideButtonExport;
        saveData.selectedExcelTemplates = this.props.model.selectedExcelTemplates;
        saveData.selectedReports = this.props.model.selectedReports;
        saveData.dataTemplateId = this.props.dataTemplateId;
        saveData.editingScenario = this.props.editingScenario;
        saveData.groupName = this.listViewGroupName.value;
        saveData.lazyLoadingAmount = this.props.model.lazyLoadingAmount;

        if (saveData.id == 0)
            saveData.art = this.props.model.art;

        const used = this.element.querySelector(".used");

        const treeNodes = used.getElementsByClassName("tree-item");

        //for (let i = 0; i < treeNodes.length; i++) {
        //    let item = treeNodes.item(i);
        //    let fieldUniqueId = item.getAttribute("data-field");

        for (let node of this.usedFields.tree.nodes) {

            //if (node.props.model.businessModel.value == fieldUniqueId) {
            if (!node.props.model.businessModel.isDeleted) {
                let saveField = {
                    // TODO Change to use the fieldName directly - usedFieldComponent settings value = fieldName can be removed then
                    name: node.props.model.businessModel.fieldName,
                    inlineEdit: node.props.model.selected == CheckedState.Checked,
                    iteration: undefined,
                    width: node.props.model.businessModel.width
                };

                if (node.props.model.businessModel.iteration != null && node.props.model.businessModel.iteration != undefined) {
                    saveField.iteration = node.props.model.businessModel.iteration;
                }
                saveData.fields.push(saveField);
            }
            //}
        }
        //}

        saveData.filters = this.props.model.filters;
        saveData.sorts = this.props.model.sorts;

        if (!saveData.name.trim()) {
            this.element.querySelector(".ansicht-name input")?.classList.add("border-danger");
        } else {
            app.showWaitPanel();

            $.ajax({
                type: "POST",
                url: app.resolveUrl("~/api/gridView/save"),
                dataType: 'json',
                contentType: "application/json; charset=utf-8",
                data: JSON.stringify(saveData),
                success: ((id) => {
                    if (this.props.isCopy || this.props.isNew) {
                        if (this.props.dontChangeUserView) {
                            if (this.props.onViewChanged) {
                                this.props.onViewChanged(id);
                            }

                            this.onHidden();

                            if (this.props.postSaveHandler) {
                                this.props.postSaveHandler(saveData.name, id);
                            }

                        } else {
                            $.ajax({
                                type: "POST",
                                url: app.resolveUrl("~/api/GridView/change/" + id + "/" + this.props.model.viewIndex),
                                success: (() => {
                                    if (this.props.onViewChanged) {
                                        this.props.onViewChanged(id);
                                        this.onHidden();
                                    }
                                    else {
                                        location.reload();
                                    }

                                }),
                                error: ((response) => {
                                    app.hideWaitPanel();
                                    alert(response.statusText + ": " + response.responseText);
                                })
                            });
                        }
                    }
                    else {
                        if (this.props.onViewChanged) {
                            this.props.onViewChanged(id);
                        }

                        this.onHidden();

                        if (this.props.dontChangeUserView) {
                            if (this.props.postSaveHandler) {
                                this.props.postSaveHandler(saveData.name, id);
                            }
                        } else {
                            location.reload();
                        }
                    }
                }),
                error: ((response) => {
                    app.hideWaitPanel();
                    alert(response.statusText + ": " + response.responseText);
                })
            });

        }

    }

    onHidden = () => {
        this.element.parentElement.removeChild(this.element);
    }
}